import { defaultColors } from '../../../Common/Services/contexts/ServicesChartsDataContext';
import { Donut } from '../../../Common/Charts/Donut';
import { useHouseholdIncomeChartsDataContext } from './hooks/useHouseholdIncomeChartsDataContext';

export const IncomeRange = () => {
    const { chartData } = useHouseholdIncomeChartsDataContext();

    return (
        <Donut
            title={'Faixa de Renda'}
            subtitles={chartData?.incomeRange?.map(
                (item) => item.description
            )}
            chartData={chartData?.incomeRange || []}
            colors={
                defaultColors.slice(0, chartData?.incomeRange?.length) ||
                []
            }
            height={350}
        />
    );
};
